import React from "react";
export default function TheBiopowerVision() {
  return <section data-section-id="256809" id="the-biopower-vision" className="relative w-full text-foreground py-24 md:py-32 overflow-hidden flex items-center justify-center bg-white light">
      <style>{`
        @keyframes shimmer {
          0% { transform: translateX(-150%); }
          50% { transform: translateX(150%); }
          100% { transform: translateX(150%); }
        }
        .animate-shimmer {
          animation: shimmer 3s cubic-bezier(0.4, 0, 0.2, 1) infinite;
        }
        .bg-bio-gradient {
          background-image: 
          linear-gradient(90deg, rgba(120,200,100,0.05) 0%, transparent 10%, transparent 90%, rgba(120,200,100,0.05) 100%),
          repeating-linear-gradient(
            to right,
            transparent,
            transparent 2px,
            rgba(200, 200, 200, 0.05) 2px,
            rgba(200, 200, 200, 0.05) 4px
          );
        }
      `}</style>

      <div className="absolute inset-0 bg-bio-gradient opacity-40 pointer-events-none" />
      
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(120,200,100,0.05)_0%,transparent_70%)] pointer-events-none" />

      <div className="page-container relative z-10 flex flex-col gap-8 md:gap-12 items-center text-center py-32 md:py-44">
        <h1 className="font-default font-bold tracking-tighter leading-tight bg-linear-to-br from-[hsl(120,60%,40%)] to-[hsl(220,10%,20%)] bg-clip-text text-transparent uppercase" style={{
        fontSize: "clamp(2.5rem, 8vw, 5rem)"
      }}>
          Nuestra Visión
        </h1>

        <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground tracking-tighter max-w-4xl uppercase">
          Transformar residuos en energía limpia para impulsar la soberanía energética de Cuba
        </h2>

        <img src="https://biopowercuba.com/wp-content/uploads/2026/06/BioPower-SRL.png" alt="BioPower SRL Logo" loading="lazy" className="h-auto object-contain" style={{
        width: "clamp(400px, 50vw, 600px)"
      }} />
      </div>
    </section>;
}